const specialData = ["Band", "Choir", "Dance Group", "Drama Plays"];

export default specialData;
